<template>
  <div class="p-4 p-md-5 mb-4 container rounded text-body-emphasis bg-bd-green d-flex flex-column flex-lg-row">
    <div class="col-lg-6 d-flex flex-column justify-content-evenly px-0">
      <h1 class="text-light open700">Install the app</h1>
      <p class="my-3 text-light open400">It's never been easier to order food. Look for the finest discounts and you'll be
        lost in a world of
        delectable food.</p>
      <div class="d-flex align-items-center justify-content-evenly flex-column flex-sm-row">
        <a href="https://play.google.com/store/apps/details?id=com.getit.badidukkan" target="_blank"><img
            src="@/assets/google-play-badge.png" alt="Google Play Badge" style="width: auto; height: 90px;" class="img-fluid"></a>
        <a href="" target="_blank"><img src="@/assets/AppStore_Badge.svg" alt="App Store Badge" class="img-fluid"></a>
      </div>
    </div>
    <img src="@/assets/bd_app.svg" alt="app" class="col-lg-6 img-fluid">
  </div>

  <div class="container py-5 my-5 text-center">
    <h1 class="open600">How Badidukkan works</h1>
    <p class="open400">Download customer app from playstore, create a account and order a food near your location.
      enjoy your food.</p>
    <img src="@/assets/bd_app_features.svg" alt="features" class="img-fluid">
  </div>

  <div class="container py- my-5 text-center">
    <h1 class="open600">Benefits of using this App</h1>
    <BDFeatCircle />
  </div>

  <div class="p-4 p-md-5 mb-4 container rounded text-body-emphasis bg-bd-green d-flex flex-column flex-lg-row">
    <img src="@/assets/bd_app_bt_1.svg" alt="app" class="col-lg-4 img-fluid">
    <div class="col-lg-4 d-flex flex-column justify-content-evenly px-0">
      <h1 class="text-light open700">Download the app</h1>
      <p class="my-3 text-light open400">Your favorite Pre-booking plateform that aims to satisfy your cravings as they
        arise! Access exclusive menus with a QR at your favorite restaurant!</p>
      <div class="d-flex align-items-center justify-content-evenly flex-column flex-sm-row">
        <a href="https://play.google.com/store/apps/details?id=com.getit.badidukkan" target="_blank"><img
            src="@/assets/google-play-badge.png" alt="Google Play Badge" style="width: auto; height: 90px;" class="img-fluid"></a>
        <a href="" target="_blank"><img src="@/assets/AppStore_Badge.svg" alt="App Store Badge" class="img-fluid"></a>
      </div>
    </div>
    <img src="@/assets/bd_app_bt_2.svg" alt="app" class="col-lg-4 img-fluid">
  </div>
</template>

<style scoped></style>

<script>
import BDFeatCircle from '@/components/BDFeatCircle.vue';

export default {
  components: { BDFeatCircle }
}
</script>
